<template>
  <div>
    <v-select
      persistent-placeholder
      placeholder="None selected   >"
      v-model="accounts_selected"
      :items="accounts"
      :item-text="view_text"
      :item-value="item_value"
      :item-disabled="is_disabled"
      :loading="loading"
      return-object
      multiple
      label="Brokers"
      hide-details
      outlined
    >
      <template v-slot:append-item>
        <div v-intersect="endIntersect"></div>
      </template>
      <template v-slot:prepend-item>
        <div class="ml-3 d-flex justify-space-around">
          <v-btn text @click="select_all_accs" small>Select All</v-btn>
          <v-btn text @click="unselect_all_accs" small>Unselect All</v-btn>
        </div>
      </template>
      <template v-slot:selection="{ item, index }">
        <span
          v-if="
            index === 0 &&
            accounts_selected.length == all_available_selectable &&
            accounts_selected.length > 1
          "
          class="grey--text"
        >
          All {{ accounts_selected.length }} selected >
        </span>
        <span
          v-else-if="
            index === 0 && accounts_selected.length <= all_available_selectable
          "
        >
          <span>{{ view_text(item) }}</span>
        </span>
        <span
          v-if="
            index === 1 && accounts_selected.length != all_available_selectable
          "
          class="grey--text text-caption ml-5"
        >
          +{{ accounts_selected.length - 1 }} more >
        </span>
      </template>
    </v-select>
  </div>
</template>
<script>
import Vuex from "vuex";

import pagedFetcher from "@/mixins/pagedFetcher";
import B from "@/mixins/brokerConstants.js";

export default {
  name: "NodeBrokerSelector",
  components: {},
  mixins: [pagedFetcher],
  props: {},
  data() {
    return {
      accounts_selected: [],
      node_brokers: [],
      accounts: [],
      total_items: 0,
      loading: false,
      broker_types: B.get_brokers(),
      delay_timer: null,
      debug: false,
      mock: false,
      B: B,
    };
  },
  methods: {
    item_value(item) {
      return `${item.id}`;
    },
    view_text(item) {
      return `${item.full_name}`;
    },
    is_disabled(item) {
      return !this.account_is_active(item);
    },
    account_is_active(a) {
      if (this.B.is_tradovate(a.broker.broker_type)) {
        return a.is_active;
      }
      return false;
    },
    select_all_accs() {
      this.accounts_selected = [];
      this.accounts.forEach((a) => {
        if (this.account_is_active(a)) {
          this.accounts_selected.push(a);
        }
      });
    },
    unselect_all_accs() {
      this.accounts_selected = [];
    },
    update_accounts(node_brokers) {
      this.accounts = [];
      let n = 1;
      for (const b of node_brokers) {
        if (this.debug) console.log("b", b);

        if (this.B.is_tradovate(b.broker_type)) {
          for (const a of b?.config_json?.tradovate_accounts) {
            n += 1;
            if (this.debug) console.log("tradovate", a);
            const acc = {
              id: n,
              name: `${a.name}`,
              full_name: `${b.name} | ${a.name} | ${this.B.get_broker_type_view(
                b.broker_type
              )}`,
              is_active: b.is_active,
              broker: b,
              account: a,
            };
            this.accounts.push(acc);
          }
        } else if (this.B.is_interactive_broker(b.broker_type)) {
          for (const a of b?.config_json?.ib_accounts) {
            n += 1;
            if (this.debug) console.log("IB", a);
            const acc = {
              id: n,
              name: `${a}`,
              full_name: `${b.name} | ${a} | ${this.B.get_broker_type_view(
                b.broker_type
              )}`,
              is_active: b.is_active,
              broker: b,
              account: a,
            };
            this.accounts.push(acc);
          }
        }
      }
      if (this.debug) console.log("accounts", this.accounts);
    },
    set_autoselect_accounts(node_brokers) {
      this.accounts_selected = [];
      for (let a of this.accounts) {
        if (this.account_is_active(a)) {
          this.accounts_selected.push(a);
        }
      }
    },
    endIntersect(e, o, isIntersecting) {
      if (isIntersecting) {
        this.do_search(true);
      }
    },
    async fetch_items(append = false) {
      if (this.debug) console.log("fetching items...");
      try {
        var response = await this.actual_fetch_data();
        if (append) {
          this.node_brokers.push.apply(
            this.node_brokers,
            response.data.results
          );
        } else {
          this.node_brokers = response.data.results;
        }
        this.update_accounts(this.node_brokers);
        this.total_items = response.data.count;
        if (this.debug) console.log(this.total_items, this.node_brokers);
      } catch (error) {
        this.show_error_message(error);
      }
    },
    do_search(next_page = false, auto_select = null) {
      if (next_page) this.skip += this.limit;
      else {
        this.skip = 0;
        this.total_items = 0;
      }
      if (this.total_items < this.skip) return;
      let self = this;
      this.loading = true;
      this.fetch_items(next_page).finally(() => {
        this.loading = false;
        if (auto_select) {
          this.set_autoselect_accounts();
        }
      });
    },
    get_url() {
      return `${this.apip.API_NODE_BROKERS_PATH}`;
    },
    delay_emit_accounts(nval) {
      if (this.delay_timer) clearTimeout(this.delay_timer);
      this.delay_timer = setTimeout(() => {
        if (this.debug)
          console.log("emit accounts_selected", this.accounts_selected);
        this.$emit("accounts_selected", this.accounts_selected);
      }, 1000);
    },
    ...Vuex.mapActions(["show_error_message", "show_info_message"]),
  },
  computed: {
    all_available_selectable() {
      return this.accounts?.filter(this.account_is_active)?.length;
    },
  },
  watch: {
    accounts_selected(nval) {
      this.delay_emit_accounts();
    },
  },
  mounted() {
    this.limit = 20;
    this.do_search(false, true);
  },
};
</script>
